const styles = theme => ({
  '@font-face': [
    {
      fontFamily: 'LUI icons',
      src: 'url(assets/fonts/lui-icons.woff) format("woff"), url(assets/fonts/lui-icons.ttf) format("truetype")',
    },
  ],
  '@global': {
    body: {
      fontFamily: 'Inter',
      fontSize: theme.fontSize,
      margin: '0',
    },
    '.lui-dialog__footer': {
      height: 'auto !important',
    },
    '.lui-dialog-container': {
      padding: '0px',
    },
  },
  main: theme.container,
  container: {
    minHeight: '100vh',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  loaderIcon: {
    width: '50px',
    height: '50px',
    border: '4px solid #ccc',
    borderTop: '4px solid #009845', // Qlik green for loader color
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
});

export default styles;
